import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ThreedviewComponent } from './views/threedview/threedview.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: '3dview',
    pathMatch: 'full', 
  },
  {
    path: '3dview',
    component: ThreedviewComponent,
    data: {
      title: '3d View Page'
    }
  }
];
@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
